import { Button, Checkbox, Collapse, message, Tooltip } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { Link, useNavigate, useParams } from "react-router-dom";
import { ReactComponent as FileImageOutlined } from "../../image/FileImageOutlined.svg";
import { DeleteOutlined } from "@ant-design/icons";
import { ReactComponent as CircleIcon } from "../../image/CircleIcon.svg";
import { Breadcrumb, Col, Form, Row, Select, Space, Spin, Upload } from "antd";
import "antd/dist/antd.min.css";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "../../styles/Main.scss";
import { getRequest, patchRequest, postRequest } from "../../axios";
import ButtonField from "../../common/htmlComponents/ButtonField";
import EmailField from "../../common/htmlComponents/EmailField";
import InputField from "../../common/htmlComponents/InputField";
import { authUserData } from "../../utils/Helper";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";

import NewDeiveryrateDriver from "./NewDeiveryrateDriver";

const { Option } = Select;

const NewAddDriver = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  // const [form] = Form.useForm();
  const { Panel } = Collapse;
  const formRef = useRef();
  const deliveryFormRef = useRef();
  const { id } = useParams();
  const DriverId = id ? atob(id) : null;
  const [sizepolicecheck, setSizepolicecheck] = useState(null);
  const [isPanelDisabled, setIsPanelDisabled] = useState(true);
  const [sizeuploaddrivinglicense, setsizeuploaddrivinglicense] =
    useState(null);
  const [refreshGrid, setRefreshGrid] = useState(false);
  const [sizeuploadvisa, setsizeuploadvisa] = useState(null);
  const [fileNamevisa, setFileNamevisa] = useState(null);
  const [fileLinkvisa, setfileLinkvisa] = useState(null);
  const [sizeuploadpassport, setsizeuploadpassport] = useState(null);
  const [fileNamepassport, setFileNamepassport] = useState(null);
  const [fileLinkpassport, setfileLinkpassport] = useState(null);
  const [fileLink, setFileLink] = useState(null);
  const [fileLinkpolice_check, setFileLinkpolice_check] = useState(null);
  const [fileName, setFileName] = useState(null);
  const [fileNamepolice_check, setFileNamepolice_check] = useState(null);

  const [uploadFile, setUploadFile] = useState("");
  const [uploadFilevisa, setuploadFilevisa] = useState("");
  const [uploadFilepassport, setuploadFilepassport] = useState("");
  const [uploadFilepolicecheck, setUploadFilepolicecheck] = useState("");
  const [mockData, setMockData] = useState([]);
  const [targetKeys, setTargetKeys] = useState(mockData);
  const [companyDocumentList, setCompanyDocumentList] = useState([]);
  const [totalCount, settotalCount] = useState(0);
  const [reload, setReload] = useState(false);
  const [stateTable, setStateTable] = useState({
    page: 1,
    ordering: "-id",
    pagesize: 10,
    search: "",
    total: 0,
  });
  const initialState = {
    name: "",
    email: "",
    address: "",
    phone: "",
    company_name: "",
    work_on: "ABN 29122051171",
    abn_number: "",
    tax_file_number: "",
    account_holder_name: "",
    account_number: "",
    bank_name: "",
    branch_name: "",
    ifsc_code: "",
    role: 3,
    emergency_contact_person_name: "",
    emergency_contact_person_no: "",
    visa_type: "Student Visa yes",
    delivery_charge: 0,
  };
  const [state, setState] = useState(initialState);
  const [btnLoading, setBtnLoading] = useState(false);
  const [apiLoading, setapiloading] = useState(false);
  const [checked, setChecked] = useState(false);
  const [companyList, setCompanyList] = useState([]);
  const [uomList, setUomList] = useState([]);

  const [deliveryRateLoading, setDeliveryRateLoading] = useState(false);



  const [addedCompanyId, setAddedCompanyId] = useState(null);
  const initialDocument = {
    driver: null,
    company: "",
    weight_start: null,
    start_unit_of_measurement: "",
    weight_end: null,
    end_unit_of_measurement: "",
    rate: null,
    currency: authUserData()?.currency || 'AUD',
  };
  const [documentState, setDocumentState] = useState(initialDocument);

  const [companyDocumentId, setCompanyDocumentId] = useState(null);

  const [loading, setLoading] = useState(false);
  // const [btnDisplay, setBtnDisplay] = useState("Add");
  useEffect(() => {
    setMockData(mockData);
    getPermissionByRole(3);
  }, [mockData]);
  useEffect(() => {
    const getCompanyDocumentList = async () => {
      setLoading(true);
      try {
        let apiResponse = await getRequest(
          `driver-delivery-rate/?driver_id=${addedCompanyId}`,
          stateTable
        );
        if (apiResponse.data.results.success === true) {
          setCompanyDocumentList(apiResponse?.data?.results?.data);
          settotalCount(apiResponse.data.count);
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };
    if (addedCompanyId !== null) {
      getCompanyDocumentList();
    }
  }, [stateTable, reload, t, refreshGrid, addedCompanyId]);
  const handleCheckboxChange = (e) => {
    setChecked(e.target.checked);
    setState((prevState) => ({
      ...prevState,
      term_condition_accept: e.target.checked,
    }));
  };
  const getCompanyList = async (data) => {
    await getRequest("company/?no_pagination=True", data).then((response) => {
      setCompanyList(response.data.data);
    });
  };
  const getUomList = async (data) => {
    await getRequest("unit-of-measurement/?no_pagination=True", data).then((response) => {
      setUomList(response.data.data);
    });
  };

  // const handleCompanyChange = (value) => {

  //   setDocumentState((prevState) => {
  //     return {
  //       ...prevState,
  //       company: value,

  //     };
  //   });


  // };
  // const handleStartUomChange = (value) => {

  //   setDocumentState((prevState) => {
  //     return {
  //       ...prevState,
  //       start_unit_of_measurement: value,

  //     };
  //   });


  // };
  // const handleEndUomChange = (value) => {

  //   setDocumentState((prevState) => {
  //     return {
  //       ...prevState,
  //       end_unit_of_measurement: value,

  //     };
  //   });


  // };

  const urls = state?.driving_license;

  let filenamelicense = "";

  try {
    if (fileLink) {
      filenamelicense = urls.split("/").pop();
    }
  } catch (e) {
    filenamelicense = "";
  }

  const urlvisa = state?.visa;


  let visa = "";

  try {
    if (fileLinkvisa) {
      visa = urlvisa.split("/").pop();
    }
  } catch (e) {
    visa = "";
  }

  const urlpassport = state?.passport;

  let passport = "";

  try {
    if (fileLinkpassport) {
      passport = urlpassport.split("/").pop();
    }
  } catch (e) {
    passport = "";
  }

  const url = state?.police_check;

  let filenamepolice_check = "";
  try {
    if (fileLinkpolice_check) {
      filenamepolice_check = url.split("/").pop();
    }
  } catch (e) {
    filenamepolice_check = "";
  }


  useEffect(() => {
    const employeeGetById = async () => {
      setapiloading(true);
      try {
        const apiResponse = await getRequest(`employee/${DriverId}/`);

        if (apiResponse.data.success) {

          const {
            id,
            status,
            role_name,
            user_data,

            ...filteredResponse
          } = apiResponse.data.data;


          formRef.current.setFieldsValue({
            ...apiResponse.data.data,


            name: apiResponse.data.data.name,

            email: apiResponse.data.data.email,
            address: apiResponse.data.data.address,
            phone: String(apiResponse.data.data.phone),
            company_name: apiResponse.data.data.company_name,
            work_on: apiResponse.data.data.work_on,

            abn_number: apiResponse.data.data.abn_number,
            tax_file_number: apiResponse.data.data.tax_file_number,
            bank_detail: apiResponse.data.data.bank_detail,
            bank_account_no: apiResponse.data.data.bank_account_no,
            emergency_contact_person_name:
              apiResponse.data.data.emergency_contact_person_name,
            emergency_contact_person_no:
              apiResponse.data.data.emergency_contact_person_no,
            visa_type: apiResponse.data.data.visa_type,
            delivery_charge: String(
              apiResponse.data.data?.delivery_charge
            ),
            term_condition_accept: true,

          });

          setIsPanelDisabled(DriverId === null ? true : false);

          setAddedCompanyId(DriverId);
          setFileLink(apiResponse.data.data.driving_license);
          setFileLinkpolice_check(apiResponse.data.data.police_check);
          setfileLinkvisa(apiResponse.data.data.visa);
          setfileLinkpassport(apiResponse.data.data.passport);

          setChecked(true);
          setState({

            ...filteredResponse,
            term_condition_accept: true,
            permission: apiResponse.data.data.permission.map(el => el.id),

          });


          // getPermissionByRole(apiResponse?.data?.data?.role);
          setapiloading(false);
        }
      } catch (error) {
        ErrorNotificationMsg(t("error_in_list_employee"));
        setapiloading(false);
      }
    };
    if (DriverId !== null) {
      employeeGetById();
    }

    getUomList();
    getCompanyList();


  }, [DriverId, t]);
  useEffect(() => {
    const getCompanyDocument = async () => {
      setDeliveryRateLoading(true);
      try {
        const apiResponse = await getRequest(`driver-delivery-rate/${companyDocumentId}`);

        if (apiResponse.data.success) {

          const datas = apiResponse.data.data;


          setDocumentState({
            company: datas.company,
            currency: datas.currency,
            employee: datas.employee,
            employee_name: datas.employee_name,
            end_unit_of_measurement: datas.end_unit_of_measurement,
            id: datas.id,
            rate: datas.rate,
            start_unit_of_measurement: datas.start_unit_of_measurement,
            weight_end: datas.weight_end,
            weight_start: datas.weight_start,
          });


          deliveryFormRef.current.setFieldsValue({
            company: datas.company,
            currency: datas.currency,
            employee: datas.employee,
            employee_name: datas.employee_name,
            end_unit_of_measurement: datas.end_unit_of_measurement,
            id: datas.id,
            rate: datas.rate,
            start_unit_of_measurement: datas.start_unit_of_measurement,
            weight_end: datas.weight_end,
            weight_start: datas.weight_start,
          });
          setDeliveryRateLoading(false);
        } else {
          ErrorNotificationMsg(t("err_getSubscription"));
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        ErrorNotificationMsg(t("err_getSubscription"));
        setDeliveryRateLoading(false);
      } finally {

        setDeliveryRateLoading(false);
      }
    };

    if (companyDocumentId !== null) {
      getCompanyDocument();
    }
  }, [companyDocumentId, t]);

  useEffect(() => {
    setDocumentState((prevState) => {
      return {
        ...prevState,
        currency: "AUD",

      };
    });
    deliveryFormRef?.current?.setFieldsValue({ currency: authUserData()?.currency })
  }, [authUserData()?.currency])

  const uploadPropslicense = {
    accept: ".jpg, .png, .jpeg",
    showUploadList: false,
    beforeUpload: (file) => {
      const isJpgOrPng =
        file.type === "image/jpeg" || file.type === "image/png";

      if (!isJpgOrPng) {
        message.error("You can only upload JPG/PNG file!");
        return Upload.LIST_IGNORE;
      } else {
        setsizeuploaddrivinglicense(file.size);
        if (file.size <= 2097152) {
          setUploadFile(file);
          setFileName(file.name);
          setFileLink(null);
          formRef.current.setFieldsValue({ driving_license: file });
        } else {
          message.error("You can upload up to 2MB!");
        }
      }
      return false;
    },
  };

  const uploadPropsvisa = {
    accept: ".jpg, .png, .jpeg",
    showUploadList: false,
    beforeUpload: (file) => {
      const isJpgOrPng =
        file.type === "image/jpeg" || file.type === "image/png";

      if (!isJpgOrPng) {
        message.error("You can only upload JPG/PNG file!");
        return Upload.LIST_IGNORE;
      } else {
        setsizeuploadvisa(file.size);
        if (file.size <= 2097152) {
          setuploadFilevisa(file);

          setFileNamevisa(file.name);
          setfileLinkvisa(null);
          formRef.current.setFieldsValue({ visa: file });
        } else {
          message.error("You can upload up to 2MB!");
        }
      }
      return false; // Prevent automatic upload
    },
  };


  const uploadpassport = {
    accept: ".jpg, .png, .jpeg",
    showUploadList: false,
    beforeUpload: (file) => {
      const isJpgOrPng =
        file.type === "image/jpeg" || file.type === "image/png";

      if (!isJpgOrPng) {

        message.error("You can only upload JPG/PNG file!");
        return Upload.LIST_IGNORE;
      } else {

        setsizeuploadpassport(file.size);
        if (file.size <= 2097152) {
          setuploadFilepassport(file);
          setFileNamepassport(file.name);
          setfileLinkpassport(null);
          formRef.current.setFieldsValue({ passport: file });
        } else {
          message.error("You can upload upto 2mb!");
          return Upload.LIST_IGNORE;
        }

      }

      return false;
    },
  };

  const uploadPropspolicecheck = {
    accept: ".jpg, .png, .jpeg",
    showUploadList: false,
    beforeUpload: (file) => {
      const isJpgOrPng =
        file.type === "image/jpeg" || file.type === "image/png";

      if (!isJpgOrPng) {

        message.error("You can only upload JPG/PNG file!");
        return Upload.LIST_IGNORE;
      } else {

        setSizepolicecheck(file.size);
        if (file.size <= 2097152) {
          setUploadFilepolicecheck(file);
          setFileNamepolice_check(file.name);
          setFileLinkpolice_check(null);
          formRef.current.setFieldsValue({ police_check: file });
        } else {
          message.error("You can upload upto 2mb!");
          return Upload.LIST_IGNORE;
        }

      }

      return false;
    },
  };
  // const getPermission = async () => {
  //   try {
  //     setapiloading(true);
  //     // const permissionArray = await getRequest("list-permission/");
  //     const permissionArray = await getRequest("create-group-permissions/");

  //     if (permissionArray.data.success) {
  //       if (permissionArray.data.response) {
  //         const formattedData = permissionArray.data.response[0].permissions.map((item) => ({
  //           key: item.id,
  //           // title: item.permission,
  //           title: item.permission.toLowerCase(),
  //           // title: item.name,
  //         }));
  //         setMockData(formattedData);
  //       }
  //       setapiloading(false);
  //     }
  //   } catch (error) {
  //     setapiloading(false);
  //     ErrorNotificationMsg("Error fetching permissions");
  //   }
  // };
  // const handleRoleSelectChangeRole = (value) => {
  //   getPermissionByRole(value);
  //   getPermission();
  // };
  const getPermissionByRole = async (id) => {
    const permissionResponse = await getRequest(
      "create-group-permissions/" + id
    );

    setTargetKeys(
      permissionResponse.data.response.permissions.map((item) => item.id)
    );
    setState((prevState) => ({
      ...prevState,
      role: id,
      permission: permissionResponse.data.response.permissions.map(
        (item) => item.id
      ),
    }));
    // setState({
    //   ...state,

    //   role: id,
    //   permission: permissionResponse.data.response.permissions.map(
    //     (item) => item.id
    //   ),
    // });
  };
  const handleFileDeletevisa = async () => {
    const apiResponse = await patchRequest(`employee/${DriverId}/visa-delete/`);
    if (apiResponse.status) {
      SuccessNotificationMsg(t("image_deleted_success"));
      setfileLinkvisa(null);
      setFileNamevisa(null);
      setsizeuploadvisa(null);

      formRef.current.setFieldsValue({ visa: null });
    }
  };
  const handleDeletevisa = () => {
    setState((prevState) => ({
      ...prevState,
      visa: null,
    }));
    setuploadFilevisa("");
    setFileNamevisa(null);
    setsizeuploadvisa(null);
    formRef.current.setFieldsValue({ visa: null });
  };

  const handleFileDeletepassport = async () => {
    const apiResponse = await patchRequest(
      `employee/${DriverId}/passport-delete/`
    );
    if (apiResponse.status) {
      SuccessNotificationMsg(t("image_deleted_success"));
      setfileLinkpassport(null);
      setFileNamepassport(null);
      setsizeuploadpassport(null);
      formRef.current.setFieldsValue({ passport: null });
    }
  };
  const handleDeletepassport = () => {
    setState((prevState) => ({
      ...prevState,
      passport: null,
    }));
    setuploadFilepassport("");
    setFileNamepassport(null);
    setsizeuploadpassport(null);
    formRef.current.setFieldsValue({ passport: null });
  };

  const handleFileDelete = async () => {
    const apiResponse = await patchRequest(
      `employee/${DriverId}/driving-license-delete/`
    );
    if (apiResponse.status) {
      SuccessNotificationMsg(t("image_deleted_success"));
      setFileLink(null);
      setFileName(null);
      setsizeuploaddrivinglicense(null);
      setUploadFile("");
      formRef.current.setFieldsValue({ driving_license: null });
    }
  };
  const handleDelete = () => {
    setState((prevState) => ({
      ...prevState,
      driving_license: null,
    }));
    setUploadFile("");
    setFileName(null);

    setsizeuploaddrivinglicense(null);
    formRef.current.setFieldsValue({ driving_license: null });
  };

  const handleDeletePolice = () => {
    setState((prevState) => ({
      ...prevState,
      police_check: null,
    }));
    setUploadFilepolicecheck("");
    setFileNamepolice_check(null);
    setSizepolicecheck(null);
    formRef.current.setFieldsValue({ police_check: null });
  };

  const handleFileDeletePoliceCheck = async () => {
    const apiResponse = await patchRequest(
      `employee/${DriverId}/police-check-delete/`
    );
    if (apiResponse.status) {
      SuccessNotificationMsg(t("image_deleted_success"));
      setUploadFilepolicecheck("");
      setFileLinkpolice_check(null);
      setFileNamepolice_check(null);
      setSizepolicecheck(null);
      formRef.current.setFieldsValue({ police_check: null });
    }
  };


  const handleRoleSelectChange = (value) => {

    setState({ ...state, work_on: value });

  };

  const handleResidentSelectChange = (value) => {

    setState({ ...state, visa_type: value });
  };


  const handleInputChange = (e) => {
    let { name, value } = e.target;
    setState({ ...state, [name]: value });
  };
  const handleInputChangeDriver = (e) => {
    let { name, value } = e.target;
    setState({ ...state, [name]: value.toLowerCase() });
    // setState({ ...state, [name]: value });
  };
  // const handleInputChangeDelivery = (e) => {
  //   let { name, value } = e.target;
  //   setDocumentState({ ...documentState, [name]: value });
  // };

  const phoneValidLength = state.phone;


  const validatePhoneNumber = () => {
    if (
      (phoneValidLength && phoneValidLength.length < 8) ||
      phoneValidLength === null ||
      phoneValidLength === ""
    ) {
      return Promise.reject(new Error("Please enter valid phone."));
    }

    return Promise.resolve();
  };

  const handleSubmit = async () => {

    const payload = {

      name: state.name,
      email: state.email,
      address: state.address,
      phone: state.phone,
      company_name: state.company_name,
      work_on: state.work_on ? state.work_on : "ABN 29122051171",
      abn_number: state.abn_number,
      tax_file_number: state.tax_file_number,
      account_holder_name: state.account_holder_name,
      account_number: state.account_number,
      bank_name: state.bank_name,
      branch_name: state.branch_name,
      ifsc_code: state.ifsc_code,
      emergency_contact_person_name: state.emergency_contact_person_name,
      emergency_contact_person_no: state.emergency_contact_person_no,
      visa_type: state.visa_type ? state.visa_type : "Student Visa yes",
      delivery_charge: state.delivery_charge,
      // role: "Driver",
      role: 3,
      permission: state.permission,

    };
    try {
      setBtnLoading(true);
      let response;


      const formData = new FormData();

      formData.append("police_check", uploadFilepolicecheck);
      formData.append("driving_license", uploadFile);
      formData.append("visa", uploadFilevisa);
      formData.append("passport", uploadFilepassport);
      formData.append("form_data", JSON.stringify(payload));

      if (DriverId === null) {
        response = await postRequest("employee/", formData);

      } else {
        response = await patchRequest(`employee/${DriverId}/`, formData);

      }
      if (response.data.success) {
        setAddedCompanyId(response?.data?.data?.id);
        setIsPanelDisabled(response?.data?.data?.id ? false : true);
        SuccessNotificationMsg(
          DriverId === null
            ? t("driver_added_successfully")
            : t("driver_updated_successfully")
        );



        setBtnLoading(false);

      }


    } catch (error) {
      if (DriverId === null) {
        ErrorNotificationMsg(

          t("error_in_adding_driver")
        );
      }
      if (DriverId !== null && !error?.message) {
        ErrorNotificationMsg(

          t("error_in_updating_driver")
        );
      }

      setBtnLoading(false);
    }
  };
  // const handleReset = () => {
  //   setDocumentState({
  //     company: "",
  //     weight_start: "",
  //     start_unit_of_measurement: "",
  //     weight_end: "",
  //     end_unit_of_measurement: "",
  //     rate: "",
  //     currency: "",
  //   });
  //   deliveryFormRef.current.setFieldsValue({
  //     company: null,
  //     weight_start: "",
  //     weight_end: "",
  //     start_unit_of_measurement: null,
  //     end_unit_of_measurement: null,
  //     rate: "",
  //     currency: ""
  //   });
  // };
  // const handleDeliveryRateSubmit = async () => {
  //   const payload = {

  //     employee: addedCompanyId,
  //     company: documentState.company,
  //     weight_start: documentState.weight_start,
  //     start_unit_of_measurement: documentState.start_unit_of_measurement,
  //     weight_end: documentState.weight_end,
  //     end_unit_of_measurement: documentState.end_unit_of_measurement,
  //     rate: documentState.rate,
  //     currency: documentState.currency ? documentState.currency : "AUD",
  //   };



  //   try {
  //     setBtnLoadingFile(true);

  //     let apiResponse;
  //     if (companyDocumentId === null) {
  //       apiResponse = await postRequest("driver-delivery-rate/", payload);
  //     } else {
  //       apiResponse = await patchRequest(`driver-delivery-rate/${companyDocumentId}/`, payload);
  //     }

  //     if (apiResponse.data.success === true) {


  //       handleRefreshGrid();

  //       SuccessNotificationMsg(
  //         companyDocumentId === null
  //           ? t("delivery_rate_added_successfully")
  //           : t("delivery_rate_updated_successfully")
  //       );
  //       setCompanyDocumentId(null);
  //       handleReset();



  //       setBtnDisplay("Add");

  //       setBtnLoadingFile(false);

  //     }
  //     setBtnLoading(false);

  //   } catch (error) {
  //     setBtnLoading(false);
  //     setBtnLoadingFile(false);

  //   }

  // };

  // TABLE OF DELIVERY RATE
  // const handleEditIconClick = (id) => {
  //   setCompanyDocumentId(id);
  //   setBtnDisplay("Edit");
  // };



  // const handleRefreshGrid = () => {
  //   setRefreshGrid((refreshGrid) => !refreshGrid);
  // };
  // const handleTableChange = async (pagination, filters, sorter, ordering) => {
  //   const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
  //   setStateTable({
  //     ...stateTable,
  //     page: pagination.current,
  //     pagesize: pagination.pageSize,
  //     ordering: orderBy,
  //   });
  // };

  // const GetSortingEnumValue = (sortField, sortOrder) => {
  //   let sortingEnumKey = "id";
  //   if (sortField === "company" && sortOrder === "ascend") {
  //     sortingEnumKey = "company__company_name";
  //   }
  //   if (sortField === "company" && sortOrder === "descend") {
  //     sortingEnumKey = "-company__company_name";
  //   }
  //   if (sortField === "weight_start" && sortOrder === "ascend") {
  //     sortingEnumKey = "weight_start";
  //   }
  //   if (sortField === "weight_start" && sortOrder === "descend") {
  //     sortingEnumKey = "-weight_start";
  //   }
  //   if (sortField === "start_unit_of_measurement" && sortOrder === "ascend") {
  //     sortingEnumKey = "start_unit_of_measurement__name";
  //   }
  //   if (sortField === "start_unit_of_measurement" && sortOrder === "descend") {
  //     sortingEnumKey = "-start_unit_of_measurement__name";
  //   }
  //   if (sortField === "weight_end" && sortOrder === "ascend") {
  //     sortingEnumKey = "weight_end";
  //   }
  //   if (sortField === "weight_end" && sortOrder === "descend") {
  //     sortingEnumKey = "-weight_end";
  //   }
  //   if (sortField === "end_unit_of_measurement" && sortOrder === "ascend") {
  //     sortingEnumKey = "end_unit_of_measurement__name";
  //   }
  //   if (sortField === "end_unit_of_measurement" && sortOrder === "descend") {
  //     sortingEnumKey = "-end_unit_of_measurement__name";
  //   }
  //   if (sortField === "rate" && sortOrder === "ascend") {
  //     sortingEnumKey = "rate";
  //   }
  //   if (sortField === "rate" && sortOrder === "descend") {
  //     sortingEnumKey = "-rate";
  //   }
  //   if (sortField === "currency" && sortOrder === "ascend") {
  //     sortingEnumKey = "currency";
  //   }
  //   if (sortField === "currency" && sortOrder === "descend") {
  //     sortingEnumKey = "-currency";
  //   }


  //   return sortingEnumKey;
  // };



  // const rowSelection = {
  //   onChange: (selectedRowKeys) => {
  //     setSelectedRow(selectedRowKeys);
  //   },
  // };

  // const debounceLoadData = debounce((value, onSearchTable) => {
  //   onSearchTable(value);
  // }, 1000);
  // const searchCallbackDelayed = (event) => {
  //   const { value } = event.target;
  //   debounceLoadData(value, onSearchTable);
  // };

  // const onSearchTable = (value) => {
  //   setStateTable({
  //     ...stateTable,
  //     search: value,
  //   });
  // };
  // const handleArchive = async (id = []) => {
  //   let ids = selectedRow;
  //   if (ids.length === 0) {
  //     ids.push(id);
  //   }
  //   try {
  //     let apiResponse = await deleteRequest("driver-delivery-rate/driver-delivery-rate-delete/", {
  //       deleted: ids,
  //     });
  //     if (apiResponse.data.success) {
  //       SuccessNotificationMsg(t("Delivery Rate Deleted Successfully"));
  //       setReload(!reload);
  //       setSelectedRow([]);

  //     } else {
  //       ErrorNotificationMsg(t("Error In Delivery Rate"));
  //     }
  //   } catch (error) {
  //   }
  // };


  // const columns = [
  //   {
  //     title: "Company",
  //     dataIndex: "company_name",
  //     key: "company",
  //     sorter: true,
  //   },

  //   {
  //     title: "Start Weight",
  //     dataIndex: "weight_start",
  //     key: "weight_start",
  //     sorter: true,
  //   },
  //   {
  //     title: "UOM",
  //     dataIndex: "start_unit_of_measurement_name",
  //     key: "start_unit_of_measurement",
  //     sorter: true,
  //   },
  //   {
  //     title: "End Weight",
  //     dataIndex: "weight_end",
  //     key: "weight_end",
  //     sorter: true,
  //   },
  //   {
  //     title: "UOM",
  //     dataIndex: "end_unit_of_measurement_name",
  //     key: "end_unit_of_measurement",
  //     sorter: true,
  //   },
  //   {
  //     title: "Rate",
  //     dataIndex: "rate",
  //     key: "rate",
  //     sorter: true,
  //   },
  //   {
  //     title: "Currency",
  //     dataIndex: "currency",
  //     key: "currency",
  //     sorter: true,
  //   },
  //   {
  //     title: "ACTION",
  //     key: "operation",
  //     fixed: "right",
  //     width: 150,
  //     render: (text, record) => (
  //       <Space>
  //         <Tooltip
  //           color={colors}
  //           placement="left"
  //           title={<span style={{ color: "#fff" }}>Edit</span>}
  //         >
  //           {authUserData()?.permission.includes(
  //             "employee|change_driverdeliveryrate",
  //           ) && (
  //               <Editicon onClick={() => handleEditIconClick(record.id)} style={{ cursor: "pointer" }} />
  //             )}
  //         </Tooltip>
  //         {authUserData()?.permission.includes(
  //           "employee|delete_driverdeliveryrate",
  //         ) && (
  //             <Popconfirm
  //               className="action"
  //               title={t("pop_delete")}
  //               okText={t("pop_ok")}
  //               cancelText={t("pop_cancel")}
  //               onConfirm={() => handleArchive(record.id)}
  //             >
  //               <Tooltip
  //                 color={colors}
  //                 placement="right"
  //                 title={<span style={{ color: "#fff" }}>Delete</span>}
  //               >
  //                 <DeleteOutlined style={{ cursor: "pointer" }} />
  //               </Tooltip>
  //             </Popconfirm>
  //           )}
  //       </Space>
  //     ),
  //   },
  // ];
  // const colors = ["#737373"];
  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            {DriverId ? <h3>{"Edit Driver"}</h3> : <h3>{"Add Driver"}</h3>}
            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Link to="/driver"> {t("pl_driver")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                {DriverId ? "Edit Driver" : "Add Driver"}
              </Breadcrumb.Item>
            </Breadcrumb>
          </div>
        </div>
      </div>

      <section className="grid-sec FormSection Container">
        <div className="FormBody">
          <Spin spinning={apiLoading}>
            <Form onFinish={handleSubmit} autoComplete="off" ref={formRef}>
              <Collapse defaultActiveKey={["1", "2", "3", "4"]}>
                <Panel header="1. Driver Personal Info" key="1">
                  <Row gutter={[10]}>
                    <Col xs={24} sm={24} md={24} lg={4} xl={4} className="TextFeild">
                      <InputField
                        name="name"
                        label={t("name")}
                        placeholder={t("pl_driver_name")}
                        rules={t("val_name")}
                        value={state.name}
                        pattern="^[A-Za-z\s]*$"

                        handleInputChange={handleInputChange}
                        max={30}
                      />
                    </Col>


                    <Col xs={24} sm={24} md={24} lg={4} xl={4} className="TextFeild">
                      <EmailField
                        name="email"
                        label={t("label_email")}
                        placeholder={t("pl_email_driver")}
                        rules={t("val_email_driver")}
                        value={state.email}
                        handleInputChange={handleInputChangeDriver}
                      />
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={4} xl={4} className="TextFeild">
                      {/* <Tooltip title={t("Flat, House no., Building, Company, Apratment")}> */}
                      <InputField
                        name="address"
                        // label={t("label_Address")}
                        placeholder={t("pl_address_2")}
                        rules={t("val_address_2")}
                        value={state.address}
                        label={
                          <span>
                            {t("label_Address")}
                            {/* <Tooltip
                              placement="top"
                              title="Flat, House no., Building, Company, Apratment"
                            > */}
                              <CircleIcon style={{ marginLeft: "6px" }} />
                            {/* </Tooltip> */}
                          </span>
                        }
                        handleInputChange={handleInputChange}
                        max={100}
                      />
                      {/* </Tooltip> */}

                    </Col>
                    <Col xs={24} sm={24} md={24} lg={4} xl={4} className="TextFeild">
                      <Form.Item
                        name="phone"
                        label={t("label_phoneNumber")}
                        placeholder={t("pl_contact_num")}
                        rules={[
                          {
                            required: true,
                            validator: validatePhoneNumber,
                            message: <Trans> {t("val_contact_num")}</Trans>,
                          },
                        ]}
                      >
                        <PhoneInput

                          country={"au"}
                          className="PhoneSection"
                          value={state.phone}
                          onChange={(phone) =>
                            setState({ ...state, phone: phone })
                          }
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={24} md={24} lg={4} xl={4} className="TextFeild">
                      <InputField
                        name="company_name"
                        label={t("label_company_name")}
                        placeholder={t("pl_company_name")}
                        // rules={t("val_company_name_2")}
                        value={state.company}
                        pattern={"^[a-zA-Z0-9\\s]+$"}
                        handleInputChange={handleInputChange}
                        max={30}
                      />
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={4} xl={4} className="TextFeild">
                      <Form.Item
                        name="work_on"
                        label={t("label_Work_on")}
                        value={state.work_on}
                        rules={[
                          {
                            required: false,
                            message: <Trans>{t("val_label_Work_on")}</Trans>,
                          },
                        ]}
                      >
                        <Select
                          showArrow

                          placeholder={t("label_role")}
                          onChange={(value) => handleRoleSelectChange(value)}
                        >
                          <Option key="1" value="ABN 29122051171">
                            ABN 29122051171
                          </Option>
                          <Option key="2" value="TFN">
                            TFN
                          </Option>
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={4} xl={4} className="TextFeild">
                      <InputField
                        name="abn_number"
                        label={t("label_ABN_Number")}
                        placeholder={t("pl_abn_number")}
                        rules={t("val_abn_number_2")}
                        nonRequiredRules={t("val_abn_number_2")}
                        pattern={"^\\d{11}$"}
                        value={state.abn_number}

                        handleInputChange={handleInputChange}
                        max={30}
                      />
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={4} xl={4} className="TextFeild">
                      <InputField
                        name="tax_file_number"
                        label={t("label_tax_file_number")}
                        placeholder={t("pl_tax_file_number_2")}
                        // rules={t("val_tax_file_number_2")}
                        nonRequiredRules={t("val_tax_file_number_2")}
                        pattern={"^\\d{8,9}$"} // Pattern for 8 or 9 digits
                        value={state.tax_file_number}

                        handleInputChange={handleInputChange}
                        max={30}
                      />
                    </Col>

                    <Col xs={24} sm={24} md={24} lg={4} xl={4} className="TextFeild">
                      <InputField
                        name="emergency_contact_person_name"
                        label={t("label_emergency_contact_person_name")}
                        placeholder={t("pl_emergency_contact_person_name")}
                        // rules={t("val_emergency_contact_person_name_2")}
                        value={state.emergency_contact_person_name}
                        pattern="^[A-Za-z\s]*$"
                        handleInputChange={handleInputChange}
                        max={30}
                      />
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={4} xl={4} className="TextFeild">
                      <Form.Item
                        name="emergency_contact_person_no"
                        label={t("label_emergency_contact_person_no")}
                        placeholder={t("pl_emergency_contact_person_no_num")}
                      // rules={[
                      //   {
                      //     required: false,
                      //     validator: validatePhoneNumber,
                      //     message: (
                      //       <Trans>
                      //         {" "}
                      //         {t("val_emergency_contact_person_number_2")}
                      //       </Trans>
                      //     ),
                      //   },
                      // ]}
                      >
                        <PhoneInput

                          country={"au"}
                          className="PhoneSection"
                          value={state.emergency_contact_person_no}
                          onChange={(emergency_contact_person_no) =>
                            setState({
                              ...state,
                              emergency_contact_person_no:
                                emergency_contact_person_no,
                            })
                          }
                        />
                      </Form.Item>
                    </Col>



                  </Row>
                </Panel>

                <Panel header="2. Bank Details" key="2">
                  <Row gutter={[10]}>
                    <Col xs={24} sm={24} md={24} lg={4} xl={4} className="TextFeild">
                      <InputField
                        name="account_holder_name"

                        label={t("label_bank_detail")}
                        placeholder={t("pl_label_bank_detail")}
                        // rules={t("val_bank_detail_2")}
                        pattern="^[A-Za-z\s]*$"
                        value={state.account_holder_name}

                        handleInputChange={handleInputChange}
                        max={30}
                      />
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={4} xl={4} className="TextFeild">
                      <InputField
                        name="account_number"
                        label={t("label_bank_account_number")}
                        placeholder={t("pl_bank_account_no_2")}
                        // rules={t("val_bank_account_no_2")}
                        value={state.account_number}
                        pattern={"^[0-9]{8,12}$"}

                        handleInputChange={handleInputChange}
                        max={30}
                      />
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={4} xl={4} className="TextFeild">
                      <InputField
                        name="bank_name"
                        label={t("label_bank_name")}
                        placeholder={t("pl_bank_name")}
                        // rules={t("val_bank_name")}
                        value={state.bank_name}

                        pattern="^[A-Za-z\s]*$"
                        handleInputChange={handleInputChange}
                        max={50}
                      />
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={4} xl={4} className="TextFeild">
                      <InputField
                        name="branch_name"
                        label={t("label_bank_branch")}
                        placeholder={t("pl_bank_branch")}
                        // rules={t("val_bank_branch")}
                        value={state.branch_name}
                        pattern={"^[a-zA-Z ]+$"}
                        handleInputChange={handleInputChange}
                        max={50}
                      />
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={4} xl={4} className="TextFeild">
                      <InputField
                        name="ifsc_code"
                        label={t("label_ifsc_code")}
                        placeholder={t("pl_ifsc_code")}
                        // rules={t("val_ifsc_code")}
                        value={state.ifsc_code}

                        handleInputChange={handleInputChange}
                        max={11}
                      />
                    </Col>


                  </Row>
                </Panel>

                <Panel header="3. Upload Document" key="3">
                  <Row gutter={[10]}>


                    <Col xs={24} sm={24} md={24} lg={4} xl={4} className="TextFeild">
                      <Form.Item
                        name="visa_type"
                        label={t("label_Visa_type")}

                        value={state.visa_type}
                        rules={[
                          {
                            required: false,
                            message: <Trans>{t("val_label_Visa_type")}</Trans>,
                          },
                        ]}
                      >
                        <Select
                          showArrow
                          placeholder={t("pl_label_Visa_type")}

                          onChange={(value) =>
                            handleResidentSelectChange(value)
                          }
                        >
                          <Option key="1" value="Student Visa yes">
                            Student Visa yes
                          </Option>
                          <Option key="2" value="Dependent Visa">
                            Dependent Visa
                          </Option>
                          <Option key="3" value="Permanent Resident">
                            Permanent Resident
                          </Option>
                          <Option key="4" value="Citizen">
                            Citizen
                          </Option>
                          <Option key="5" value="Other">
                            Other
                          </Option>
                        </Select>
                      </Form.Item>
                    </Col>


                    <Col xs={24} sm={24} md={24} lg={4} xl={4} className="TextFeild">
                      <Form.Item

                        name="passport"
                        className="BrowsButtonSec"
                        label={t("label_passport")}
                        rules={[
                          {
                            required: false,
                            message: <Trans>{t("val_label_passport")}</Trans>
                          },
                        ]}
                      >
                        <Upload
                          className="BrowsButton"
                          {...uploadpassport}
                          name="passport"
                        >
                          <Button icon={<FileImageOutlined />}>
                            {t("pl_choose_document")}
                          </Button>
                          <div className="condition">
                            {" "}
                            <p
                              style={{
                                color:
                                  sizeuploadpassport > 2097152
                                    ? "red"
                                    : "GrayText",
                              }}
                            >
                              {t("upload_fileSize")} {t("upload_imagefileType")}
                            </p>
                          </div>
                        </Upload>
                        {sizeuploadpassport <= 2097152 && (
                          <>
                            <Space
                              className="uploadedfile"
                              size={[12, 16]}

                            >
                              <div

                              >
                                <a
                                  href={fileLinkpassport}
                                  className="link-color"
                                  target="_blank"
                                  rel="noreferrer"

                                >
                                  {fileLinkpassport
                                    ? passport
                                    : fileNamepassport}
                                </a>
                                {fileLinkpassport && (
                                  <DeleteOutlined
                                    onClick={handleFileDeletepassport}
                                  />
                                )}
                                {fileNamepassport && (
                                  <DeleteOutlined
                                    onClick={handleDeletepassport}
                                  />
                                )}
                              </div>
                            </Space>
                          </>
                        )}
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={4} xl={4} className="TextFeild">
                      <Form.Item

                        name="visa"
                        className="BrowsButtonSec"
                        label={t("label_Visa")}
                        rules={[
                          {
                            required: false,
                            message: <Trans>{t("val_label_Visa")}</Trans>,
                          },
                        ]}
                      >
                        <Upload
                          className="BrowsButton"
                          {...uploadPropsvisa}
                          name="visa"
                        >
                          <Button icon={<FileImageOutlined />}>
                            {t("pl_choose_document")}
                          </Button>
                          <div className="condition">
                            {" "}
                            <p
                              style={{
                                color:
                                  sizeuploadvisa > 2097152 ? "red" : "GrayText",
                              }}
                            >
                              {t("upload_fileSize")} {t("upload_imagefileType")}
                            </p>
                          </div>
                        </Upload>
                        {sizeuploadvisa <= 2097152 && (
                          <>
                            <Space
                              className="uploadedfile"
                              size={[12, 16]}

                            >
                              <div

                              >
                                <a
                                  href={fileLinkvisa}
                                  className="link-color"
                                  target="_blank"
                                  rel="noreferrer"

                                >
                                  {fileLinkvisa ? visa : fileNamevisa}
                                </a>

                                {fileLinkvisa && (
                                  <DeleteOutlined
                                    onClick={handleFileDeletevisa}
                                    style={{ marginLeft: "8px" }}
                                  />
                                )}
                                {fileNamevisa && (
                                  <DeleteOutlined
                                    onClick={handleDeletevisa}
                                    style={{ marginLeft: "8px" }}
                                  />
                                )}
                              </div>
                            </Space>
                          </>
                        )}
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={24} md={24} lg={4} xl={4} className="TextFeild">
                      <Form.Item
                        // pan card
                        name="driving_license"
                        className="BrowsButtonSec"
                        label={t("label_driving_license")}
                        rules={[
                          {
                            required: false,
                            message: <Trans>{t("pl_upload_police_check")}</Trans>,
                          },
                        ]}
                      >
                        <Upload
                          className="BrowsButton"
                          {...uploadPropslicense}
                          name="driving_license"
                        >
                          <Button icon={<FileImageOutlined />}>
                            {t("pl_choose_document")}
                          </Button>
                          <div className="condition">
                            {" "}
                            <p
                              style={{
                                color:
                                  sizeuploaddrivinglicense > 2097152
                                    ? "red"
                                    : "GrayText",
                              }}
                            >
                              {t("upload_fileSize")} {t("upload_imagefileType")}
                            </p>
                          </div>
                        </Upload>
                        {sizeuploaddrivinglicense <= 2097152 && (
                          <>
                            <Space
                              className="uploadedfile"
                              size={[12, 16]}

                            >
                              <div

                              >
                                <a
                                  href={fileLink}
                                  className="link-color"
                                  target="_blank"
                                  rel="noreferrer"

                                >
                                  {fileLink ? filenamelicense : fileName}
                                </a>
                                {fileLink && (
                                  <DeleteOutlined onClick={handleFileDelete} />
                                )}
                                {fileName && (
                                  <DeleteOutlined onClick={handleDelete} />
                                )}
                              </div>
                            </Space>
                          </>
                        )}
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={24} md={24} lg={4} xl={4} className="TextFeild">
                      <Form.Item
                        className="BrowsButtonSec"
                        label={t("label_police_check")}
                        name="police_check"
                        rules={[
                          {
                            required: false,
                            message: <Trans>{t("pl_upload_police_check")}</Trans>,
                          },
                        ]}
                      >
                        <Upload
                          className="BrowsButton"
                          {...uploadPropspolicecheck}
                          name="police_check"
                        >
                          <Button icon={<FileImageOutlined />}>
                            {t("pl_choose_document")}
                          </Button>
                          <div className="condition">
                            {" "}
                            <p
                              style={{
                                color:
                                  sizepolicecheck > 2097152
                                    ? "red"
                                    : "GrayText",
                              }}
                            >
                              {t("upload_fileSize")} {t("upload_imagefileType")}
                            </p>
                          </div>
                        </Upload>

                        {sizepolicecheck <= 2097152 && (
                          <>
                            <Space
                              className="uploadedfile"
                              size={[12, 16]}

                            >
                              <div

                              >
                                <a
                                  href={fileLinkpolice_check}
                                  className="link-color"
                                  target="_blank"
                                  rel="noreferrer"

                                >
                                  {fileLinkpolice_check
                                    ? filenamepolice_check
                                    : fileNamepolice_check}
                                </a>
                                {fileLinkpolice_check && (
                                  <DeleteOutlined
                                    onClick={handleFileDeletePoliceCheck}
                                  />
                                )}
                                {fileNamepolice_check && (
                                  <DeleteOutlined
                                    onClick={handleDeletePolice}
                                  />
                                )}
                              </div>
                            </Space>
                          </>
                        )}
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={24} md={24} lg={4} xl={4} className="TextFeild">
                      <Form.Item
                        className="BrowsButtonSec"
                        label={t("label_term_condition_accept")}
                        name="term_condition_accept"
                        valuePropName="checked"
                        rules={[
                          {
                            required: true,
                            message: (
                              <Trans>{t("val_term_condition_accept")}</Trans>
                            ),
                          },
                          () => ({
                            validator(_, value) {
                              if (!value) {
                                return Promise.reject(
                                  new Error(
                                    t("val_terms_and_conditions")
                                  )
                                );
                              }
                              return Promise.resolve();
                            },
                          }),
                        ]}
                      >
                        <Checkbox
                          onChange={handleCheckboxChange}
                          checked={checked}
                        >
                          <Link to="/terms-and-conditions">
                            {t("Please Read Terms and Conditions")}
                          </Link>
                        </Checkbox>
                      </Form.Item>
                    </Col>

                  </Row>
                </Panel>


              </Collapse>
              <div className="FormFooter">
                <ButtonField
                  className="CancelGradiantBtn"
                  type="primary"
                  htmlType="button"
                  size="medium"
                  label="Cancel"
                  onClick={() => navigate("/driver")}
                />
                <ButtonField
                  className="SaveGradiantBtn"
                  type="primary"
                  htmlType="submit"
                  label="Save"
                  onClick={handleSubmit}
                  disabled={!checked || btnLoading}
                  loading={btnLoading}
                />
              </div>
            </Form>
          </Spin>
          <Collapse>

            <Panel header="3. Driver Delivery Rate" key="3" >

              {/* <>

                <>
                  {authUserData()?.permission.includes(
                    "employee|add_driverdeliveryrate",
                  ) && (
                      <Spin spinning={deliveryRateLoading}>

                        <Form
                          onFinish={handleDeliveryRateSubmit}
                          autoComplete="off"
                          ref={deliveryFormRef}
                        >

                          <Row gutter={[10]}>
                            <Col xs={24} sm={24} md={24} lg={4} xl={4} className="TextFeild">
                              <Form.Item
                                name="company"
                                label={t("pl_company_onboarding")}
                                rules={[
                                  {
                                    required: true,
                                    message: <Trans>{t("val_company_onboarding")}</Trans>,
                                  },
                                ]}
                              >
                                <Select
                                  placeholder={t("pl_select_company_onboarding")}
                                  showArrow
                                  showSearch

                                  value={documentState?.company}
                                  name="company"
                                  optionFilterProp="children"
                                  onChange={(value) => handleCompanyChange(value)}
                                >
                                  {companyList?.map((item) => (
                                    <Option key={item.id} value={item.id}>
                                      {item.company_name}
                                    </Option>
                                  ))}
                                </Select>
                              </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={24} lg={4} xl={4} className="TextFeild">

                              <Form.Item
                                name="weight_start"
                                label={t("label_weight_start")}
                                rules={[
                                  {
                                    required: true,
                                    pattern: /^[0-9]+(\.[0-9]+)?$/,
                                    message: <Trans>{t("val_weight_start")}</Trans>,
                                  },

                                ]}

                              >
                                <Input

                                  name="weight_start"
                                  value={documentState?.weight_start}
                                  onChange={handleInputChangeDelivery}
                                  placeholder={t("pl_weight_start")}

                                />
                              </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={24} lg={4} xl={4} className="TextFeild">
                              <Form.Item
                                name="start_unit_of_measurement"
                                label={t("label_unit_of_measurement")}
                                rules={[
                                  {
                                    required: true,
                                    message: <Trans>{t("val_uom")}</Trans>,
                                  },
                                ]}
                              >
                                <Select
                                  placeholder={t("pl_unit_of_measurement")}
                                  showArrow
                                  showSearch

                                  value={documentState?.start_unit_of_measurement}
                                  name="start_unit_of_measurement"
                                  optionFilterProp="children"
                                  onChange={(value) => handleStartUomChange(value)}
                                >
                                  {uomList?.map((item) => (
                                    <Option key={item.id} value={item.id}>
                                      {item.name}
                                    </Option>
                                  ))}
                                </Select>
                              </Form.Item>
                            </Col>

                            <Col xs={24} sm={24} md={24} lg={4} xl={4} className="TextFeild">

                              <Form.Item
                                name="weight_end"
                                label={t("label_weight_end")}
                                rules={[
                                  {
                                    required: true,
                                    pattern: /^[0-9]+(\.[0-9]+)?$/,
                                    message: <Trans>{t("val_weight_end")}</Trans>,
                                  },
                                ]}

                              >
                                <Input
                                  type="text"
                                  name="weight_end"
                                  value={documentState?.weight_end}
                                  onChange={handleInputChangeDelivery}
                                  placeholder={t("pl_weight_end")}
                                />
                              </Form.Item>
                            </Col>

                            <Col xs={24} sm={24} md={24} lg={4} xl={4} className="TextFeild">
                              <Form.Item
                                name="end_unit_of_measurement"
                                label={t("label_unit_of_measurement")}
                                rules={[
                                  {
                                    required: true,
                                    message: <Trans>{t("val_uom")}</Trans>,
                                  },
                                ]}
                              >
                                <Select
                                  placeholder={t("pl_unit_of_measurement_enter")}
                                  showArrow
                                  showSearch

                                  value={documentState?.end_unit_of_measurement}
                                  name="end_unit_of_measurement"
                                  optionFilterProp="children"
                                  onChange={(value) => handleEndUomChange(value)}
                                >
                                  {uomList?.map((item) => (
                                    <Option key={item.id} value={item.id}>
                                      {item.name}
                                    </Option>
                                  ))}
                                </Select>
                              </Form.Item>
                            </Col>

                            <Col xs={24} sm={24} md={24} lg={4} xl={4} className="TextFeild">

                              <Form.Item
                                name="rate"
                                label={t("label_rate")}
                                rules={[
                                  {
                                    required: true,
                                    pattern: /^[0-9]+(\.[0-9]+)?$/,
                                    message: <Trans>{t("val_rate")}</Trans>,
                                  },
                                ]}

                              >
                                <Input
                                  type="text"
                                  name="rate"
                                  value={documentState?.rate}
                                  onChange={handleInputChangeDelivery}
                                  placeholder={t("pl_rate")}
                                />
                              </Form.Item>
                            </Col>

                            <Col xs={24} sm={24} md={24} lg={4} xl={4} className="TextFeild">

                              <Form.Item
                                name="currency"
                                label={t("pl_currency")}

                              >
                                <Input
                                  type="text"
                                  label={t("label_currency")}
                                  name="currency"
                                  value={documentState.currency}
                                  disabled
                                  handleInputChange={handleInputChangeDelivery}
                                  placeholder={t(authUserData()?.currency)}
                                />
                              </Form.Item>
                            </Col>

                            <ButtonField
                              type="primary"
                              className="SaveGradiantBtn mt-3"
                              htmlType="Submit"
                              label={t(btnDisplay)}
                              loading={btnLoadingFile}
                            />
                          </Row>
                        </Form>
                      </Spin>
                    )}
                  <>
                    <Row className="tblheader">

                      <Col xs={24} sm={24} md={24} lg={24} xl={24} className="TextFeild">
                        <div className="searchwrp" style={{ display: 'flex', justifyContent: "flex-end" }}>
                          <Form form={form}>
                            <Form.Item name="search" initialValue="">
                              <Search
                                prefix={
                                  <img
                                    src={SearchIcon}
                                    alt="SearchIcon"
                                    className="SearchIcon"
                                    width={22}
                                  />
                                }
                                placeholder={t("pl_search")}
                                onChange={searchCallbackDelayed}

                              />
                            </Form.Item>

                          </Form>
                          {authUserData()?.permission.includes(
                            "employee|delete_driverdeliveryrate",
                          ) && (
                              <>
                                {selectedRow.length > 0 && (

                                  <Popconfirm
                                    className="action"
                                    title={t("pop_delete")}
                                    okText={t("pop_ok")}
                                    cancelText={t("pop_cancel")}
                                    placement="left"
                                    onConfirm={() => handleArchive()}
                                  >

                                    <ButtonField

                                      className="BlueShadowBtnDelivery"
                                      type="primary"
                                      htmlType="button"
                                      label={t("Delete")}
                                    />

                                  </Popconfirm>
                                )}
                              </>
                            )}
                        </div>



                      </Col>
                    </Row>
                    {authUserData()?.permission.includes(
                      "employee|view_driverdeliveryrate",
                    ) && (
                        <Table
                          rowSelection={rowSelection}
                          columns={columns}
                          rowKey={(record) => record.id}
                          dataSource={companyDocumentList}
                          loading={loading}
                          pagination={{
                            defaultCurrent: stateTable.page,
                            defaultPageSize: stateTable.pagesize,
                            total: totalCount,
                            showTotal: (total) => `Total ${total} items`,
                            showSizeChanger: true,
                            locale: {
                              items_per_page: "Items / Page",
                            },
                          }}
                          onChange={handleTableChange}
                        />
                      )}
                  </>
                </>

              </> */}
              <NewDeiveryrateDriver/>
            </Panel>

          </Collapse>
        </div>

      </section>
    </>
  );
};

export default NewAddDriver;
